import MuiGlobalStyles from '@mui/material/GlobalStyles';
import {type VFC} from 'react';
import {getFontFaceStyles} from './getFontFaceStyles';
import {getTokens} from './getTokens';

export interface GlobalStylesProps {
    excludeFontStyles?: boolean;
}

export const themeAttributeMap = {
    jdGreen: 'jd-green',
    jdBlack: 'jd-black'
} as const;

export const GlobalStyles: VFC<GlobalStylesProps> = (props) => (
    <MuiGlobalStyles
        styles={(theme): string => `
            ${!props.excludeFontStyles ? getFontFaceStyles() : ''}

            :root {
                ${getTokens(theme)}
            }
        `}
    />
);
